import { IDmEmailConfig } from "../../../models/response/email/IDmEmailConfig";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';

export const eDmEmailConfigDefine = {
    LOAD_START: undefined,
    LOAD_SUCCCES: [] as IDmEmailConfig[],
    LOAD_ERROR: "",
   
}
export const eEmailConfigActionTypeIds = generateActionTypeIds(eDmEmailConfigDefine, "EMAIL_CONFIG")
export type IDmEmailConfigActionTypes = IGenericActionType<typeof eDmEmailConfigDefine, "EMAIL_CONFIG">
